import { render, staticRenderFns } from "./AddressKR.vue?vue&type=template&id=09d80214&"
import script from "./AddressKR.vue?vue&type=script&lang=js&"
export * from "./AddressKR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports